import { Collapse } from "@mui/material";
import { useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import moment from "moment";
import { IoIosAddCircleOutline } from "react-icons/io";
import StaffCollapsible from "./StaffCollapsible";
import ModalAddStaff from "./ModalAddStaff";

const AddRegisterFinalPreview = ({
  formik,
  dataTitle,
  isFetchingTitle,
  dataRole,
  isFetchingRole,
  setActiveStep,
  dataBusiness,
  isFetchingBusiness,
  dataBank,
  isFetchingBank,
}) => {
  const [collapseSarana, setCollapseSarana] = useState(true);
  const [collapseOwner, setCollapseOwner] = useState(true);
  const [collapseStaff, setCollapseStaff] = useState(true);
  const [collapseArr, setCollapseArr] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [openModal, setOpenModal] = useState(false);

  const handleClickPreview = (url) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    setCollapseArr([...Array(formik.values.staff.length).fill(false)]);
  }, [formik.values.staff]);

  return (
    <div>
      <div className="border rounded-md p-3 w-full shadow-md mb-3 bg-white">
        <div
          className="flex justify-between items-center hover:text-gray-300 cursor-pointer"
          onClick={() => setCollapseSarana(!collapseSarana)}
        >
          <div>
            <p className="text-[14px] font-semibold">Informasi Perusahaan</p>
          </div>
          {collapseSarana ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <Collapse in={collapseSarana}>
          <div className="mt-4">
            <button
              type="button"
              className="!rounded-md p-2 border-2 hover:bg-gray-100 w-full border-gray-300 mb-4"
              onClick={() => setActiveStep(0)}
            >
              Ubah
            </button>

            <div className="mb-2">
              <p>Bidang Usaha</p>
              <p>
                {dataBusiness
                  ? dataBusiness.find(
                      (item) =>
                        item.id === formik.values.company.business_field_id
                    )?.name
                  : ""}
              </p>
            </div>

            <div className="mb-4">
              <p>Nama Usaha</p>
              <p>{formik.values.company.name}</p>
            </div>

            <p className="text-[14px] font-semibold mb-2">NPWP</p>
            <div className="mb-2">
              <p>No. NPWP Usaha</p>
              <p>{formik.values.company.npwp.number}</p>
            </div>
            <div className="mb-2">
              <p>Alamat NPWP</p>
              <p>{formik.values.company.npwp.address}</p>
            </div>
            <div className="mb-2">
              <p>Provinsi</p>
              <p>{formik.values.company.npwp.province}</p>
            </div>
            <div className="mb-2">
              <p>Kota</p>
              <p>{formik.values.company.npwp.city}</p>
            </div>
            <div className="mb-2">
              <p>Kecamatan</p>
              <p>{formik.values.company.npwp.district}</p>
            </div>
            <div className="mb-2">
              <p>Kelurahan/Desa</p>
              <p>{formik.values.company.npwp.subdistrict}</p>
            </div>
            <div className="mb-2">
              <p>Kode Pos</p>
              <p>{formik.values.company.npwp.postalcode}</p>
            </div>

            <p className="text-[14px] font-semibold mb-2">Alamat Usaha</p>
            <div className="mb-2">
              <p>Alamat Usaha</p>
              <p>{formik.values.company.business.address}</p>
            </div>
            <div className="mb-2">
              <p>Provinsi</p>
              <p>{formik.values.company.business.province}</p>
            </div>
            <div className="mb-2">
              <p>Kota</p>
              <p>{formik.values.company.business.city}</p>
            </div>
            <div className="mb-2">
              <p>Kecamatan</p>
              <p>{formik.values.company.business.district}</p>
            </div>
            <div className="mb-2">
              <p>Kelurahan/Desa</p>
              <p>{formik.values.company.business.subdistrict}</p>
            </div>
            <div className="mb-2">
              <p>Kode Pos</p>
              <p>{formik.values.company.business.postalcode}</p>
            </div>

            <div className="mb-2">
              <p>Nomor Handphone</p>
              <p>{formik.values.company.phone}</p>
            </div>
            <div className="mb-2">
              <p>Nomor Induk Berusaha</p>
              <p>{formik.values.company.nib}</p>
            </div>
            <div className="mb-2">
              <p>Kode E-report/SIPNAP</p>
              <p>{formik.values.company.sipnap_code}</p>
            </div>
            <div className="mb-2">
              <p>Surat Izin Usaha</p>
              <p>{formik.values.company.permission_letter_id}</p>
            </div>
            <div className="mb-2">
              <p>Masa Berlaku Surat Izin Usaha</p>
              <p>
                {moment(formik.values.company.permission_letter_expired).format(
                  "DD MMMM YYYY"
                )}
              </p>
            </div>
            <div className="mb-2">
              <p>Nama Bank</p>
              <p>{formik.values.company.bank}</p>
            </div>
            <div className="mb-2">
              <p>Nomor Rekening Bank</p>
              <p>{formik.values.company.bank_account_number}</p>
            </div>
            <div className="mb-2">
              <p>Nama Pemilik Rekening</p>
              <p>{formik.values.company.bank_account_name}</p>
            </div>
            <div className="mb-2">
              <p>Nomor Induk Berusaha</p>
              <button
                className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                onClick={() =>
                  handleClickPreview(formik.values.company.files.nib)
                }
              >
                Lihat Berkas
              </button>
            </div>
            <div className="mb-2">
              <p>Surat Izin Berusaha</p>
              <button
                className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                onClick={() =>
                  handleClickPreview(formik.values.company.files.izin_sarana)
                }
              >
                Lihat Berkas
              </button>
            </div>
            <div className="mb-2">
              <p>Stampel Usaha</p>
              <button
                className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                onClick={() =>
                  handleClickPreview(formik.values.company.files.stempel_sarana)
                }
              >
                Lihat Berkas
              </button>
            </div>
            <div className="mb-2">
              <p>NPWP</p>
              <button
                className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                onClick={() =>
                  handleClickPreview(formik.values.company.files.npwp)
                }
              >
                Lihat Berkas
              </button>
            </div>
          </div>
        </Collapse>
      </div>

      <div className="border rounded-md p-3 w-full shadow-md mb-3 bg-white">
        <div
          className="flex justify-between items-center hover:text-gray-300 cursor-pointer"
          onClick={() => setCollapseOwner(!collapseOwner)}
        >
          <div>
            <p className="text-[14px] font-semibold">Informasi Pemilik</p>
          </div>
          {collapseOwner ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <Collapse in={collapseOwner}>
          <div className="mt-4">
            <button
              type="button"
              className="!rounded-md p-2 border-2 hover:bg-gray-100 w-full border-gray-300 mb-4"
              onClick={() => setActiveStep(1)}
            >
              Ubah
            </button>

            <div className="mb-2">
              <p>Nama</p>
              <p>{formik.values.owner.name}</p>
            </div>
            <div className="mb-2">
              <p>No. KTP</p>
              <p>{formik.values.owner.id}</p>
            </div>
            <div className="mb-2">
              <p>No. Handphone</p>
              <p>{formik.values.owner.phone}</p>
            </div>
            <div className="mb-2">
              <p>NPWP</p>
              <p>{formik.values.owner.npwp}</p>
            </div>
            <div className="mb-2">
              <p>Email</p>
              <p>{formik.values.owner.email}</p>
            </div>
            <div className="mb-2">
              <p>No KTP</p>
              <button
                className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                onClick={() =>
                  handleClickPreview(formik.values.owner.files.ktp)
                }
              >
                Lihat Berkas
              </button>
            </div>
            <div className="mb-2">
              <p>NPWP</p>
              <button
                className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                onClick={() =>
                  handleClickPreview(formik.values.owner.files.npwp)
                }
              >
                Lihat Berkas
              </button>
            </div>
          </div>
        </Collapse>
      </div>

      <div className="border rounded-md p-3 w-full shadow-md mb-3 bg-white">
        <div
          className="flex justify-between items-center hover:text-gray-300 cursor-pointer"
          onClick={() => setCollapseStaff(!collapseStaff)}
        >
          <div>
            <p className="text-[14px] font-semibold">Data Staff</p>
          </div>
          {collapseStaff ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <Collapse in={collapseStaff}>
          <div className="mt-4">
            <button
              type="button"
              className="w-full bg-blue-500 text-white hover:bg-gray-300 !rounded-md flex items-center gap-2 justify-center p-2 mb-4"
              onClick={() => {
                setSelectedIndex(-1);
                setOpenModal(true);
              }}
            >
              <IoIosAddCircleOutline />
              Tambah Staff
            </button>
            {formik.values.staff.map((item, i) => (
              <StaffCollapsible
                collapseArr={collapseArr}
                setCollapseArr={setCollapseArr}
                formik={formik}
                dataTitle={dataTitle}
                dataRole={dataRole}
                item={item}
                i={i}
                setSelectedIndex={setSelectedIndex}
                setOpenModal={setOpenModal}
              />
            ))}
          </div>
        </Collapse>
      </div>

      <ModalAddStaff
        formik={formik}
        open={openModal}
        setOpen={setOpenModal}
        index={selectedIndex}
        dataTitle={dataTitle}
        isFetchingTitle={isFetchingTitle}
        dataRole={dataRole}
        isFetchingRole={isFetchingRole}
      />
    </div>
  );
};

export default AddRegisterFinalPreview;
